module.exports = __webpack_public_path__ + "static/media/mln-logo-transparent.c05784c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/mln-logo-transparent.png
// module id = 197
// module chunks = 0